var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhoneNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.943 3.49469C7.4223 2.97399 6.57808 2.97399 6.05738 3.49469L4.23423 5.31784C3.54556 6.00652 3.31836 6.95075 3.60264 7.74467C7.00147 17.2365 15.5466 23.2794 21.2232 25.4027C21.9761 25.6843 22.8988 25.4401 23.5657 24.6898L25.5653 22.4402C26.0546 21.8898 26.005 21.0471 25.4546 20.5578L22.5429 17.9697C22.2019 17.6665 21.7296 17.5588 21.2908 17.6842L18.7657 18.4057C18.0723 18.6038 17.2533 18.641 16.4604 18.332C13.227 17.0716 11.4336 14.336 10.6922 12.5639C10.3555 11.7592 10.3962 10.9267 10.5941 10.234L11.2871 7.80867C11.4201 7.34308 11.2903 6.84197 10.9479 6.49957L7.943 3.49469ZM4.17177 1.60907C5.73386 0.0469739 8.26652 0.0469775 9.82862 1.60907L12.8335 4.61395C13.8607 5.64115 14.2502 7.14449 13.8512 8.54126L13.1582 10.9666C13.0825 11.2316 13.1044 11.4204 13.1522 11.5346C13.7281 12.9111 15.1018 14.9403 17.4289 15.8474C17.564 15.9001 17.769 15.9171 18.0332 15.8416L20.5582 15.1201C21.8744 14.7441 23.2915 15.0672 24.3146 15.9766L27.2262 18.5648C28.8774 20.0324 29.0261 22.5607 27.5584 24.2118L25.5588 26.4614C24.2972 27.8807 22.255 28.6357 20.289 27.9004C14.0975 25.5845 4.82567 19.0704 1.09207 8.64365C0.417147 6.75879 1.02533 4.75551 2.34861 3.43222L4.17177 1.60907Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneNo);
export default __webpack_public_path__ + "static/media/ic_phone-no.8009857cf541e93a5bc11925d3db0f6d.svg";
export { ForwardRef as ReactComponent };